import Forms from '../../html5/forms/all.forms.js';
import {fields as AppFields} from '../../html5/forms/app.fields.js';
import router from '../router.js';

/**
 * 根据表单配置信息胜场data对象
 * @param  {Object} data 需要覆盖的默认字段内容
 * @return {Object}      根据配置转换的组件data
 */
export const getInitFormData = function (data = {}) {
  const { history } = router;
  const { current : { name } } = history;
  console.log(AppFields)
  return Forms[name] ? Forms[name].reduce((acc, item) => {
    // const fieldInfo = AppFields[item];
    acc[item] = typeof acc[item] !== 'undefined' ? acc[item] : '';

    return acc;
  }, data): data;
};
